export default "__VITE_ASSET__DKj3NAT2__"